import React from 'react';
import useEmployeeBackgroundCheckService from 'domain/people/employee/PersonalLegal/backgroundcheck/shared/employeeBackgroundCheckService';
import { List } from 'framework/list';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import BackgroundCheckContent from '../shared/BackgroundCheckContent';

const LS_KEY = 'BackgroundCheckList';

const EmployeeBackgroundCheckSummary = () => {
  const { search } = useEmployeeBackgroundCheckService();
  const employeeId = useEmployeeId();

  if (!employeeId) return null;

  return (
    <List
      getDataMethod={search}
      defaultSortOrder="DESC"
      defaultSortField="performedAt"
      localStorageKey={LS_KEY}
      disableUrlUpdate
    >
      <BackgroundCheckContent employeeId={employeeId} />
    </List>
  );
};

export default EmployeeBackgroundCheckSummary;
